/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/FreecellRandom',['lodash',
        'SolitaireShared/CardLogic/CardValue',
        'SolitaireShared/CardLogic/CardSuit'
    ],
    function (_, CardValue, CardSuit) {
    "use strict";

        var FreecellRandom = function (seed) {
            this.initFreecellRandom(seed);
        };

        FreecellRandom.prototype.initFreecellRandom = function (seed) {
            this.DealNumber = seed;
            this._state = seed;
        };

        FreecellRandom.prototype.GetNext = function () {
            this._state = ((((214013 * this._state) + 2531011) % (2 << 30))) >>> 0;

            return (this._state / (2 << 15)) >>> 0;
        };


        FreecellRandom.GetDeal = function (seed)
        {
            var retval = [];
            var cards = [];
            var prng = new FreecellRandom(seed);

            _.forEach (CardValue.Values, function (value)
            {
                _.forEach (CardSuit, function (suit)
                {
                    if (suit != CardSuit.None && value != CardValue.Values.Joker)
                    {
                        cards.push({Key: value, Value: suit});
                    }
                });
            });

            for (var i = 0, j = 1; i < 52; i++)
            {
                var index = (prng.GetNext() % cards.length);
                var tmp = cards[cards.length - 1];
                cards[cards.length - 1] = cards[index];
                cards[index] = tmp;

                //change direction for every second row. bug MS-74903
                if ((j % 2) == 0)
                    retval[(8 * j - (i % 8)) - 1 ] = cards[cards.length - 1];
                else
                    retval[i] = cards[cards.length - 1];

                cards.splice(cards.length - 1); // TODO - cards.pop()?

                if ((i + 1) % 8 == 0)
                    j++;
            }

            return retval;
        };

        return FreecellRandom;
});
